import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../../../styles/globalStyle';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Form, Row, Col, Space } from 'antd';
import {
  theme,
  ButtonAnt,
  InputComponent,
  Text,
  SelectComponent,
} from '@pfmam/pfmam';
import ReviewWireAccounts from './reviewWireAccounts';
import RenderSelectAccountsComponent from '../selectAccounts';
import { CaretDownOutlined } from '@ant-design/icons';
import { getStateHash } from '../../../utils/common';

const ButtonWrapper = styled(Space)`
  justify-content: flex-end;
  width: 100%;
  min-width: 100%;
  .primary {
    width: 160px;
  }
  ${(props) =>
    props.spacing &&
    css`
      margin-top: 16px;
    `}
`;

const AddEditWireAccounts = ({
  defaultAddEditAccObj,
  addEditAccountObject,
  setAddEditAccountObject,
}) => {
  const [isAddAccount, setIsAddAccount] = useState(true);
  const [wireAccountData, setWireAccountData] = useState(null);
  const [selectAccounts, setSelectAccounts] = useState(false);
  const [isReviewWireAccount, setIsReviewWireAccount] = useState(false);
  const [isWireAccountCompleted, setIsWireAccountCompleted] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (addEditAccountObject.selectedRecord) {
      const selectedRecord = addEditAccountObject.selectedRecord;
      setIsAddAccount(false);
      form.setFieldsValue({ ...selectedRecord });
    }
  }, [addEditAccountObject, form]);

  const onFinish = (values) => {
    setSelectAccounts(true);
    setWireAccountData({ ...wireAccountData, ...values });
  };
  const handleBack = () => {
    setAddEditAccountObject({ ...defaultAddEditAccObj });
  };

  const getTitle = () => {
    let label = '';
    if (isWireAccountCompleted) {
      label = 'Wire Account Submitted';
    } else if (isReviewWireAccount) {
      label = 'Review Wire Account';
    } else {
      label = `${isAddAccount ? 'Add' : 'Edit'} Wire Account`;
    }
    return (
      <>
        <Text
          fontSize="36px"
          color={`${theme.colors.black_secondary}`}
          lineheight="44px"
          label={label}
          icon={
            isWireAccountCompleted ? (
              <CheckCircleOutlined
                style={{ color: `${theme.colors.pie_green}`, marginRight: '0' }}
              />
            ) : null
          }
          margin={isWireAccountCompleted ? '0 0 16px' : '0 0 32px'}
        />
        {isWireAccountCompleted && (
          <Text
            label="You will be notified when this linked account is approved for transactions"
            fontSize={`${theme.font_size.size_xl}`}
            color={`${theme.colors.grey_tertiary}`}
            lineheight="24px"
            margin="0 0 32px"
          />
        )}
      </>
    );
  };
  return (
    <>
      <Box maxwidth="590px" width="100%" margin="0 auto" padding="77px 0 0">
        {getTitle()}
        <Box
          boxcolor={`${theme.colors.white}`}
          padding="32px 32px 48px"
          radius="4px"
        >
          {isReviewWireAccount ? (
            <ReviewWireAccounts
              form={form}
              wireAccountData={wireAccountData}
              isWireAccountCompleted={isWireAccountCompleted}
              setIsWireAccountCompleted={setIsWireAccountCompleted}
              setIsReviewWireAccount={setIsReviewWireAccount}
              handleBack={handleBack}
            />
          ) : (
            <>
              {selectAccounts ? (
                <RenderSelectAccountsComponent
                  setSelectAccounts={setSelectAccounts}
                  setIsReviewAccount={setIsReviewWireAccount}
                  form={form}
                  onFinish={onFinish}
                />
              ) : (
                <Form
                  form={form}
                  name="basic"
                  layout="vertical"
                  onFinish={onFinish}
                  requiredMark={false}
                  className="forms"
                >
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="Bank Name"
                        name="bankName"
                        rules={[
                          {
                            required: true,
                            message: 'Bank Name Required',
                          },
                        ]}
                      >
                        <InputComponent
                          type="default"
                          placeholder="Add Bank Name"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Bank City"
                        name="bankCity"
                        rules={[
                          {
                            required: true,
                            message: 'Bank City Required',
                          },
                        ]}
                      >
                        <InputComponent type="default" placeholder="Add City" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Bank State"
                        name="bankState"
                        rules={[
                          {
                            required: true,
                            message: 'Bank State Required',
                          },
                        ]}
                      >
                        <SelectComponent
                          option={getStateHash()}
                          placeholder="Select a State"
                          suffixIcon={<CaretDownOutlined />}
                          dropdownClassName="form-select-dropdown"
                          bordered={true}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="Nickname"
                        name="nickName"
                        rules={[
                          {
                            required: true,
                            message: 'Nickname Required',
                          },
                        ]}
                      >
                        <InputComponent
                          type="default"
                          placeholder="Add a Nickname"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="Bank Account Number"
                        name="accnumber"
                        rules={[
                          {
                            required: true,
                            message: 'Bank Account Number Required',
                          },
                        ]}
                      >
                        <InputComponent
                          type="default"
                          placeholder="Add Account Number"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="ABA or Routing Number"
                        name="routing"
                        rules={[
                          {
                            required: true,
                            message: 'Routing Number Required',
                          },
                        ]}
                      >
                        <InputComponent
                          type="default"
                          placeholder="Add ABA or Routing Number"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="Beneficiary Name"
                        name="beneficiaryName"
                        rules={[
                          {
                            required: true,
                            message: 'Beneficiary Name Required',
                          },
                        ]}
                      >
                        <InputComponent
                          type="default"
                          placeholder="Add a Beneficiary Name"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="Beneficiary Account Number (Optional)"
                        name="beneficiaryAccNumber"
                      >
                        <InputComponent
                          type="default"
                          placeholder="Add Beneficiary Account Number"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="Beneficiary Details (Optional)"
                        name="beneficiaryDetails"
                      >
                        <InputComponent
                          type="default"
                          placeholder="Add Beneficiary Details"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <ButtonWrapper size={12} spacing>
                    <ButtonAnt
                      label="Cancel"
                      type="secondary"
                      htmlType="button"
                      onClick={() => handleBack()}
                    />
                    <ButtonAnt label="Next" type="primary" htmlType="submit" />
                  </ButtonWrapper>
                </Form>
              )}
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default AddEditWireAccounts;
